import {FC, useEffect, useRef, useState} from 'react';
import {Box} from '@mui/material';
import Button from '@components/Button';
import Select from '@components/Select';
import Input from '@components/Inputs/Input';
import {FIELD, FIELD_LABEL, PLACEHOLDER} from '@constants/field';
import {Field, useFormikContext} from 'formik';
import {setRequiredLabel} from '@helpers/form';
import {options} from '../helpers';
import {SelectOptionsType} from '@/utils/types';
import {FORM, TEXT} from '@/utils/constants';
import {createTeamMemberFormStyle} from './CreateTeamMemberForm.styles';
import {useAppDispatch} from '@/store/hooks';
import {createTeamMemberPassword, generatedPasswordSelector} from '@/store/orgatization-team';
import {LoginFormValues} from '@/components/Organization/Login/LoginForm/formConfiguration';
import {useSelector} from 'react-redux';
import {getErrorMessage} from '@/utils/helpers';
import {toast} from 'react-toastify';

const CreateTeamMemberForm: FC = () => {
  const {setFieldValue, values} = useFormikContext<LoginFormValues>();
  const generatedPassword = useSelector(generatedPasswordSelector);

  const [roleValue, setRoleValue] = useState(options[0]);

  const dispatch = useAppDispatch();

  const isFirstRender = useRef(true);

  const updateRole = (_: any, role: SelectOptionsType) => {
    setRoleValue(role);
    setFieldValue(FIELD.role, role.name);
  };

  const handleGeneratePassword = async () => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
    }
    try {
      await dispatch(createTeamMemberPassword()).unwrap();
    } catch (error) {
      toast.error(getErrorMessage(error));
    }
  };

  useEffect(() => {
    if (isFirstRender.current) {
      setFieldValue(FIELD.password, '');
      setFieldValue(FIELD.role, roleValue.name);
      return;
    }

    if (generatedPassword) {
      setFieldValue(FIELD.password, generatedPassword);
    }
  }, [generatedPassword, setFieldValue]);

  return (
    <Box>
      <Box sx={createTeamMemberFormStyle.form} component={FORM}>
        <Box sx={createTeamMemberFormStyle.formRow}>
          <Field
            id={FIELD.firstName}
            name={FIELD.firstName}
            placeholder={PLACEHOLDER.enterFirstName}
            label={setRequiredLabel(FIELD_LABEL.firstName)}
            component={Input}
          />

          <Field
            id={FIELD.lastName}
            name={FIELD.lastName}
            placeholder={PLACEHOLDER.enterLastName}
            label={setRequiredLabel(FIELD_LABEL.lastName)}
            component={Input}
          />
        </Box>

        <Field
          id={FIELD.userName}
          name={FIELD.userName}
          placeholder={PLACEHOLDER.userName}
          label={setRequiredLabel(FIELD_LABEL.userName)}
          component={Input}
        />

        <Box sx={createTeamMemberFormStyle.formRow}>
          <Field
            id={FIELD.password}
            name={FIELD.password}
            placeholder={PLACEHOLDER.enterPassword}
            label={setRequiredLabel(FIELD_LABEL.password)}
            component={Input}
            sx={createTeamMemberFormStyle.passwordIcon}
            value={values.password}
          />
          <Button title="Auto-generate" variant={TEXT} onClick={handleGeneratePassword} />
        </Box>
        <Field
          id={FIELD.role}
          name={FIELD.role}
          label={setRequiredLabel(FIELD_LABEL.role)}
          component={Select}
          options={options}
          defaultValue={roleValue.name}
          onChange={updateRole}
        />
        <Field
          id={FIELD.emailForPassword}
          name={FIELD.emailForPassword}
          placeholder={PLACEHOLDER.enterEmail}
          label={setRequiredLabel(FIELD_LABEL.emailForPassword)}
          component={Input}
        />
      </Box>
    </Box>
  );
};

export default CreateTeamMemberForm;
